export default "__VITE_ASSET__C$rLqfMM__"